import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'
import { SVETOFOR_REQUESTABLE_TYPE } from 'Pages/logs'

export class SvetoforLogModel {
	@deserialize public id: number
	@deserialize public created_at: string
	@deserialize public response_body: object[]
	@deserialize public response_headers: object
	@deserialize public partner_inn: string
	@deserialize public response_code: number
	@deserialize public requestable_type: SVETOFOR_REQUESTABLE_TYPE

	public get time_formatted(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}
}
